import { render, staticRenderFns } from "./ProsafetyNew.vue?vue&type=template&id=4b81cd57&"
import script from "./ProsafetyNew.vue?vue&type=script&lang=js&"
export * from "./ProsafetyNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports